'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactComponentErrors = require('react-component-errors');

var _reactComponentErrors2 = _interopRequireDefault(_reactComponentErrors);

var _options = require('./options');

var _options2 = _interopRequireDefault(_options);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

_reactComponentErrors.config.errorHandler = function (errorReport) {
  var message = errorReport.error.message.replace(/'/g, '\\\'');

  var test = 'test(\'' + errorReport.component + ' should not throw "' + message + '" on ' + errorReport.method + '\', () => {\n  const props = ' + JSON.stringify(errorReport.props) + '\n  const wrapper = shallow(<' + errorReport.component + ' {...props} />)\n  const instance = wrapper.instance()\n  const args = ' + JSON.stringify(errorReport.arguments ? [].concat(_toConsumableArray(errorReport.arguments)) : []) + '\n\n  expect(() => instance.' + errorReport.method + '(...args)).not.toThrowError(\'' + message + '\')\n})';

  _options2.default.log(test);

  throw errorReport.error;
};

var fixIt = function fixIt(Component) {
  (0, _reactComponentErrors2.default)(Component);

  return Component;
};

exports.default = fixIt;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-fix-it/dist/fix-it.js
// module id = 558
// module chunks = 0 1